import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectInput } from '../../interfaces/select-input';
import { Select } from 'primeng/select';
import { MessageModule } from 'primeng/message';

@Component({
  selector: 'app-input-select',
  imports: [Select, ReactiveFormsModule, FormsModule, MessageModule],
  templateUrl: './input-select.component.html',
  styleUrl: './input-select.component.scss'
})
export class InputSelectComponent {
  @Input() form!: FormGroup;
  @Input() field!: string;
  @Input() label!: string;
  @Input() options: SelectInput[] = [];
  @Input() placeholder!: string;

  }